import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import SwiperCore, { Pagination, EffectFade, Autoplay } from 'swiper/core';

// Enable Swiper Paginate, Fade Effect and Autoplay

SwiperCore.use([Pagination, EffectFade, Autoplay]);

@Component({
    selector: 'app-pb-gallery',
    templateUrl: './pb-gallery.component.html',
    styleUrls: ['./pb-gallery.component.scss']
})
export class PbGalleryComponent implements OnInit {

    @Input() content: any = {};
    @Input() module: any = {};
    padding_top: any = '';
    padding_bottom: any = '';
    items: any = [];
    images: any = [];
    domainUrl: string = environment.webUrl;
    swiperInstance: any;
    isBegin: boolean = true;
    isEnd: boolean = false;

    // A swiper config which is responsive and shows partial slides

    public responsivePartialOverflowConfig: any = {
        slidesPerView: 1.2,
        spaceBetween: 15,
        centerInsufficientSlides: true,
        centeredSlidesBounds: true,
        watchOverflow: true, // Automatically hides pagination when not needed
        pagination: { clickable: true },
        breakpoints: {
            576: {
                slidesPerView: 2.2
            },
            768: {
                slidesPerView: 3.2
            },
            992: {
                slidesPerView: 6
            }
        }
    };

    constructor() { }

    ngOnInit(): void {

        this.content.forEach(element => {
            var item = {
                content: element.data,
                alignment: this.determineAlignment(element.alignment),
                padding: this.determinePadding(element.padding),
                type: element.item.type
            }

            if (element.item.type == 'IMAGE') {
                item.content = this.domainUrl + '/' + element.data;
                this.images.push(item);
            } else {
                this.items.push(item);
            }
        });

        this.padding_top = this.module.padding_top; // Module Padding
        this.padding_bottom = this.module.padding_bottom;

    }

    /**
     * Alignment is returned as LEFT, CENTER, RIGHT
     * Determine class based on response
     */
    determineAlignment(alignment) {

        if (alignment == 'LEFT') {
            return 'text-left';
        } else if (alignment == 'CENTER') {
            return 'text-center';
        } else if (alignment == 'RIGHT') {
            return 'text-right';
        }

    }

    /**
     * Padding is returned as SMALL, MEDIUM, LARGE, XLARGE
     * Determine pixels based on response
     */
    determinePadding(padding) {

        if (padding == 'SMALL') {
            return '10';
        } else if (padding == 'MEDIUM') {
            return '15';
        } else if (padding == 'LARGE') {
            return '30';
        } else if (padding == 'XLARGE') {
            return '60';
        }

    }

    /**
     * When swiper is ready then run the update so that the slide size is correct
     * @param swiper 
     */
    onSwiper(swiper) {

        this.swiperInstance = swiper;

        setTimeout(() => {
            // swiper.update();
        }, 1500);

    }

    /**
     * Using slidechange to disable / enable the next and previous buttons
     */
    onSlideChange() {

        this.isBegin = this.swiperInstance.isBeginning;
        this.isEnd = this.swiperInstance.isEnd;

    }

    /**
     * Slides to the next image
     */
    gotoNext() {

        this.swiperInstance.slideNext();

    }

    /**
     * Slides to the previous image
     */
    gotoPrevious() {

        this.swiperInstance.slidePrev();

    }

}
